module.exports = __webpack_public_path__ + "static/media/desktop.7817050c.svg";